import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    maxWidth: 580
  },
  mainLabel: {
    marginBottom: theme.spacing(4)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(6)
  },
  buttons: {
    padding: theme.spacing(0, 6)
  }
});

export default makeStyles(styles);
